import React from 'react';
import { classNames } from '../../utilities/css.js';
import styles from './ActionMenu.scss.js';
import { RollupActions } from './components/RollupActions/RollupActions.js';
import { Actions } from './components/Actions/Actions.js';

function ActionMenu(_ref) {
  var _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? [] : _ref$actions,
      _ref$groups = _ref.groups,
      groups = _ref$groups === void 0 ? [] : _ref$groups,
      rollup = _ref.rollup,
      rollupActionsLabel = _ref.rollupActionsLabel;

  if (actions.length === 0 && groups.length === 0) {
    return null;
  }

  var actionMenuClassNames = classNames(styles.ActionMenu, rollup && styles.rollup);
  var rollupSections = groups.map(function (group) {
    return convertGroupToSection(group);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: actionMenuClassNames
  }, rollup ? /*#__PURE__*/React.createElement(RollupActions, {
    accessibilityLabel: rollupActionsLabel,
    items: actions,
    sections: rollupSections
  }) : /*#__PURE__*/React.createElement(Actions, {
    actions: actions,
    groups: groups
  }));
}

function hasGroupsWithActions() {
  var groups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return groups.length === 0 ? false : groups.some(function (group) {
    return group.actions.length > 0;
  });
}

function convertGroupToSection(_ref2) {
  var title = _ref2.title,
      actions = _ref2.actions;
  return {
    title: title,
    items: actions
  };
}

export { ActionMenu, hasGroupsWithActions };